"use client"

import type { FunctionComponent, PropsWithChildren } from "react"

import dynamic from "next/dynamic"
import { useState } from "react"

import { IconButton } from "@jobteaser/spark/components/IconButton"
import { InfoCircleOutlined } from "@jobteaser/spark/components/Icons/InfoCircleOutlined"

import styles from "./ComplianceModal.module.css"

type ComplianceModalProps = PropsWithChildren<{
  closeLabel: string
  title: string
}>

const ModalDynamic = dynamic(() => import("@/modules/layouts/components/Modal/Modal").then(mod => mod.Modal))

export const ComplianceModal: FunctionComponent<ComplianceModalProps> = ({ children, closeLabel, title }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleModalOpen = (): void => setIsModalOpen(true)
  const handleModalClose = (): void => setIsModalOpen(false)

  return (
    <>
      <IconButton
        aria-label={title}
        className={styles.button}
        icon={InfoCircleOutlined}
        onClick={handleModalOpen}
        size="small"
      />

      {isModalOpen && (
        <ModalDynamic closeLabel={closeLabel} onClose={handleModalClose} title={title}>
          {children}
        </ModalDynamic>
      )}
    </>
  )
}
